(function($) {

   var sync1 = $("#sync1");
	var sync2 = $("#sync2");
	var flag = false;
	var duration = 300;

	sync1.owlCarousel({
		items: 1,
		lazyLoad:false,
		margin: 0,
		nav:false,
		dots:false,
		loop:false,
	}).on('changed.owl.carousel', function(e) {
		var index = e.item.index - 2;
		sync2.trigger('to.owl.carousel', [index, duration, true]);
	});

	sync2.on('initialized.owl.carousel', function() {
	}).owlCarousel({
		margin:0,
		items:4,
		nav:false,
		dots:false,
		navText:[" "," "],
		center:false,
		loop:false,
	}).on('click','.slider-item',function() {
		sync1.trigger('to.owl.carousel',[parseInt($(this).attr('data-index')),duration,true]);
	});

   //-------------------------------------------
   //Set CF7 Markup
   //-------------------------------------------
   function setCF7() {

      $('select').wrap('<div class="ui-front"></div>');

      $('select').selectmenu({
			create:function(event,ui){
				$(this).next().next().removeClass('ui-front');
				$(this).next().children('.ui-selectmenu-text').text('Inquiry');
			}
		});
   }

   function fixFooter() {
      if ($('body').height() < $(window).height()) {
         $('footer').css('margin-top',$(window).height() - $('body').height());
      }
   }

   function personheight() {
      $('.person-box').height($('.person-box').width());
      //$('.home-box').height($('.home-box').width());

      $('.person-box').slice(-4).css('border-bottom','0');
   }

   //-------------------------------------------
   //MatchHeight these elements
   //-------------------------------------------
   function matchHeightAll() {
      var match_selectors = [
         '.content-column'
      ];

      for (var i=0; i < match_selectors.length; i++) {
         $(match_selectors[i]).matchHeight();
      }
   }

   //-------------------------------------------
   //Set dimension of elements
   //-------------------------------------------
   function setDimensions() {

      if ( !$('body').hasClass('page-template-template-project') && !$('body').hasClass('page-template-default') && !$('body').hasClass('page-template-template-team')) {

         $('#rotating-banner').height($(window).height());
         $('#rotating-banner .slider-item').height($(window).height());
         $('#rotating-banner .owl-video-wrapper').height($(window).height());
      }


   }

   $(document).ready(function(){

      matchHeightAll();
      setDimensions();
      fixFooter();

      $('.side-nav .burger-btn').click(function() {
         $('.side-nav').toggleClass('opened');
         $(this).toggleClass('opened');
      });

      $('body >.burger-btn').click(function() {
         $('.responsive-nav').toggleClass('opened');
         $(this).toggleClass('opened');
      });

      personheight();

      $('[href="#"]').click(function(e) {
         e.preventDefault();
         if ($(this).parent().children('.sub-menu').is(':visible')) {
            $(this).parent().children('.sub-menu').slideUp();
         } else {
            $('[href="#"]').not($(this)).parent().children('.sub-menu').slideUp();
            $(this).parent().children('.sub-menu').slideDown();
         }
      });

      //-------------------------------------------
   	//Initialize Home Banner
   	//-------------------------------------------
      if ($('#rotating-banner .slider-item').length > 1) {
         $('#rotating-banner').on('initialized.owl.carousel',function(){
            if ($('.banner-dots .owl-dot').length < 2) {
               $('.banner-dots').hide();
            }
         }).owlCarousel({
      		items:1,
      		margin:0,
      		loop:false,
      		autoplay:true,
            video:false,
            center:true,
      		autoplayTimeout : 5500,
      		autoplaySpeed:700,
            nav:false,
            dots:true,
            dotsContainer: '.banner-dots'
      	});
      }


      $('.directions-toggle').click(function(){
         $('.contact-wrapper').slideUp();
         id = $(this).attr('data-id');
         $('.directions-wrapper[data-id="'+id+'"]').slideToggle();
      });

      $('.contact-toggle').click(function(){
         $('.directions-wrapper').slideUp();
         id = $(this).attr('data-id');
         $('.contact-wrapper[data-id="'+id+'"]').slideToggle();
      });

      // console.log(location.search.replace('?', '').split('='));

      //if ($(window).width() < 1024) {
         get_param = location.search.replace('?', '').split('=');
         //console.log(get_param);
         if (get_param[0] === 'pri_tag') {
            // console.log('hello');
            $('html, body').animate({
                 scrollTop: $(".projects-wrapper").offset().top
             }, 400);
         }
      //}

      $('.directions-close, .contact-close').click(function(){
         $(this).parent('div').slideUp();
      });



      $('.person-box').click(function(e) {
         e.preventDefault();
         var prev_clicked = $(this).attr('data-clicked');
         console.log(prev_clicked);
         if ($(window).width() < 1025) {
            if (prev_clicked === 'false') {
               $(this).children('.overlay').css('opacity',1);
               $(this).attr('data-clicked','true');
            } else {
               window.location.href = $(this).attr('href');
            }
         } else {
            window.location.href = $(this).attr('href');
         }

      });

   });

   $(window).load(function(){
      setDimensions();
      setCF7();
      fixFooter();
      $('.initial-hidden').css('opacity',1);

      $('.side-nav .main-menu>li.menu-item-has-children .sub-menu>li').each(function(){
         if ($(this).hasClass('current-menu-item')) {
            $(this).parent('.sub-menu').toggle();
         }
      });

   });

   $(window).resize(function() {
      setDimensions();
      personheight();
      fixFooter();
   });


})(jQuery); // Fully reference jQuery after this point.
